import { Dialog } from "@mui/material";

import { Vendor } from "views/Vendors/Vendor/Vendor";

import { EDIT_MODAL_STYLES } from "editConfig";

export function QuickAddVendor(props) {
  const { open, onClose, initialNameValue, onAdd } = props;

  return (
    <Dialog open={open} onClose={onClose} {...EDIT_MODAL_STYLES}>
      <Vendor
        key={open}
        name={initialNameValue}
        onAdd={onAdd}
        onClose={onClose}
        fromForm={true}
      />
    </Dialog>
  );
}
